// Line Items — an attached signature image cut down to its ink (SignPad).
// Pure: works on an ImageData-shaped { data: Uint8ClampedArray RGBA }, so
// the suite runs it in node.

// An attached image's ink: the paper (the image's own light — the 85th
// percentile of its brightness, so a grey phone photo works too) becomes
// transparent, darker pixels keep their colour with an opacity that grows
// with how much darker than the paper they are. A transparent pixel is
// paper. Returns how many pixels carry ink. Mutates the ImageData.
export function inkOnly(img) {
  const d = img.data; const n = d.length / 4;
  const lum = new Uint8ClampedArray(n); const hist = new Uint32Array(256); let solid = 0;
  for (let i = 0; i < n; i++) {
    const o = i * 4;
    if (d[o + 3] < 20) { lum[i] = 255; continue; }
    const l = Math.round(0.299 * d[o] + 0.587 * d[o + 1] + 0.114 * d[o + 2]);
    lum[i] = l; hist[l]++; solid++;
  }
  let paper = 255;
  if (solid) { let seen = 0; for (let l = 0; l < 256; l++) { seen += hist[l]; if (seen >= solid * 0.85) { paper = l; break; } } }
  const cut = Math.max(40, paper - 45); const span = Math.max(40, cut * 0.5);
  let ink = 0;
  for (let i = 0; i < n; i++) {
    const o = i * 4; const l = lum[i];
    if (d[o + 3] < 20 || l >= cut) { d[o + 3] = 0; continue; }
    d[o + 3] = Math.min(255, Math.round(((cut - l) * 255) / span));
    if (d[o + 3] > 40) ink++;
  }
  return ink;
}
